module.exports = __webpack_public_path__ + "static/bitmap-giulio-bertolotti-87e7a5aaf42bd715fe65de75b15697b1.png";